// extracted by mini-css-extract-plugin
export var square = "styles-module--square--ee40f";
export var square1 = "styles-module--square1--cf6a2";
export var square2 = "styles-module--square2--6526e";
export var square3 = "styles-module--square3--6999c";
export var square4 = "styles-module--square4--599c9";